<template>
    <manual-transfer-popup
        v-if="isShowFinalPopup"
        v-model:paymentDTO="paymentDto"
        v-model:_orderId="orderId"
        v-model:_vehiclesId="vehiclesId"
        @close="closePopup"
    />
    <ManualTransferConfirmPopup
        v-else-if="isShowConfirmPopup"
        @close="closePopup"
        @back="goBack"
        @confirm="confirm"
    />
    <template v-else>
        <div class="popup">
            <div class="popup-content">
                <img src="/img/close-btn.svg" class="modal__close" @click="closePopup" />
                <div class="popup-text">
                    <div class="popup-title">
                        <i18n-t keypath="payment.paymentPopup.title" />
                    </div>
                </div>
                <div class="centered-container">
                    <a href="" @click.prevent="selectManual" class="centered-link">
                        <i18n-t keypath="payment.paymentPopup.manualTransfer" />
                    </a>
                </div>
                <ul class="custom-list">
                    <li class="custom-item">
                        <i18n-t keypath="payment.paymentPopup.attention" />
                    </li>
                </ul>
            </div>
        </div>
    </template>
</template>

<style scoped lang="scss">
@import "public/css/utils/vars.scss";
@import "public/css/utils/mixins.scss";
@import "public/css/utils/utils.scss";
.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    position: relative;
    width: 440px;
    max-height: 100%;
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 4px;
}

.close-popup-btn {
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
}

.popup-text {
    text-align: center;
}

.popup-title,
.popup-description {
    width: 100%;
}

.button-container button {
    width: 150px;
    padding: 10px;
}

.centered-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

.centered-link {
    font-weight: 400;
    font-size: 12px;
}

.custom-list {
    width: 100%;
    max-height: 100%;
    height: auto;
    border-radius: 4px;
    background: rgba(228, 234, 240, 1);
    padding: 20px;
}

.custom-item {
    width: 100%;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
    text-align: left;
    margin-bottom: 5px;
    color: rgba(98, 118, 144, 1);
}
.btn-spinner {
    margin-bottom: c-rem(-5);
    margin-left: 20px;
    width: c-rem(20);
    height: c-rem(20);
}
</style>

<script lang="ts">
import { PaymentPopup } from "@/dashboard/my-orders/new-popup/payment-popup/payment-popup";

export default PaymentPopup;
</script>
